module.exports = __webpack_public_path__ + "static/1980-genesis-2b243a8eebdce8f687741b4ee7626f29.png";